var createFeed = function(that){
    let this_vue = that;
    var bzName;
    let val = this_vue.symbol.split('/')[0];
    if(val == 'CMGCA0'){
      bzName = 'XAU/USDT';
    }else if(val == 'CMSIA0'){
      bzName = 'XAG/USDT';
    }else if(val == 'CMHGA0'){
      bzName = 'BRT/USDT';
    }else if(val == 'NECLI0'){
      bzName = 'OILFUT/USDT';
    }else if(val == 'NEHOI0'){
      bzName = 'NYMEX/USDT';
    }else if(val == 'NENGA0'){
      bzName = 'NG/USDT';
    }else if(val == 'NEPAA0'){
      bzName = 'XPD/USDT';
    }else if(val == 'NEPLA0'){
      bzName = 'PTB/USDT';
    }else if(val == 'NEQMA0'){
      bzName = 'QMOIL/USDT';
    }else if(val == 'NERBA0'){
      bzName = 'RBOB/USDT';
    }else{
      bzName = val + '/USDT';
    }
    let Datafeed = {};


    Datafeed.DataPulseUpdater = function(datafeed, updateFrequency) {
        this._datafeed = datafeed;
        this._subscribers = {};

        this._requestsPending = 0;
        var that = this;

        var update = function() {
            if (that._requestsPending > 0) {
                return;
            }

            for (var listenerGUID in that._subscribers) {
                var subscriptionRecord = that._subscribers[listenerGUID];
                var resolution = subscriptionRecord.resolution;

                var datesRangeRight = parseInt((new Date().valueOf()) / 1000);


                //	BEWARE: please note we really need 2 bars, not the only last one
                //	see the explanation below. `10` is the `large enough` value to work around holidays
                var datesRangeLeft = datesRangeRight - that.periodLengthSeconds(resolution, 10);

                that._requestsPending++;

                (function(_subscriptionRecord) { // eslint-disable-line
                    that._datafeed.getBars(_subscriptionRecord.symbolInfo, resolution, datesRangeLeft, datesRangeRight, function(bars) {
                            that._requestsPending--;

                            //	means the subscription was cancelled while waiting for data
                            if (!that._subscribers.hasOwnProperty(listenerGUID)) {
                                return;
                            }

                            if (bars.length === 0) {
                                return;
                            }

                            var lastBar = bars[bars.length - 1];
                            if (!isNaN(_subscriptionRecord.lastBarTime) && lastBar.time < _subscriptionRecord.lastBarTime) {
                                return;
                            }

                            var subscribers = _subscriptionRecord.listeners;

                            //	BEWARE: this one isn't working when first update comes and this update makes a new bar. In this case
                            //	_subscriptionRecord.lastBarTime = NaN
                            var isNewBar = !isNaN(_subscriptionRecord.lastBarTime) && lastBar.time > _subscriptionRecord.lastBarTime;

                            //	Pulse updating may miss some trades data (ie, if pulse period = 10 secods and new bar is started 5 seconds later after the last update, the
                            //	old bar's last 5 seconds trades will be lost). Thus, at fist we should broadcast old bar updates when it's ready.
                            if (isNewBar) {
                                if (bars.length < 2) {
                                    throw new Error('Not enough bars in history for proper pulse update. Need at least 2.');
                                }

                                var previousBar = bars[bars.length - 2];
                                for (var i = 0; i < subscribers.length; ++i) {
                                    subscribers[i](previousBar);
                                }
                            }

                            _subscriptionRecord.lastBarTime = lastBar.time;

                            for (var i = 0; i < subscribers.length; ++i) {
                                subscribers[i](lastBar);
                            }
                        },

                        //	on error
                        function() {
                            that._requestsPending--;
                        });
                })(subscriptionRecord);
            }
        };

        if (typeof updateFrequency != 'undefined' && updateFrequency > 0) {
            setInterval(update, updateFrequency);
        }
    };

    Datafeed.DataPulseUpdater.prototype.periodLengthSeconds = function(resolution, requiredPeriodsCount) {
        var daysCount = 0;

        if (resolution === 'D') {
            daysCount = requiredPeriodsCount;
        } else if (resolution === 'M') {
            daysCount = 31 * requiredPeriodsCount;
        } else if (resolution === 'W') {
            daysCount = 7 * requiredPeriodsCount;
        } else {
            daysCount = requiredPeriodsCount * resolution / (24 * 60);
        }
        return daysCount * 24 * 60 * 60;
    };

    Datafeed.DataPulseUpdater.prototype.subscribeDataListener = function(symbolInfo, resolution, newDataCallback, listenerGUID) {
        this._datafeed._logMessage('Subscribing ' + listenerGUID);

        if (!this._subscribers.hasOwnProperty(listenerGUID)) {
            this._subscribers[listenerGUID] = {
                symbolInfo: symbolInfo,
                resolution: resolution,
                lastBarTime: NaN,
                listeners: []
            };
        }

        this._subscribers[listenerGUID].listeners.push(newDataCallback);
    };

    Datafeed.DataPulseUpdater.prototype.unsubscribeDataListener = function(listenerGUID) {
        this._datafeed._logMessage('Unsubscribing ' + listenerGUID);
        delete this._subscribers[listenerGUID];
    };

    Datafeed.Container = function(updateFrequency){
        this._configuration = {
            supports_search: false,
            supports_group_request: false,
            //supported_resolutions: ['1', '3', '5', '15', '30', '60', '120', '240', '360', '720', '1D', '3D', '1W', '1M'],
            supported_resolutions: ['1', '5', '15', '30', '60','1D', '1W'],
            supports_marks: true,
            supports_timescale_marks: true,
            exchanges: ['gh']
        };

        this._barsPulseUpdater = new Datafeed.DataPulseUpdater(this, updateFrequency || 10 * 1000);
        // this._quotesPulseUpdater = new Datafeed.QuotesPulseUpdater(this);

        this._enableLogging = true;
        this._callbacks = {};

        this._initializationFinished = true;
        this._fireEvent('initialized');
        this._fireEvent('configuration_ready');
    };

    Datafeed.Container.prototype._fireEvent = function(event, argument) {
        if (this._callbacks.hasOwnProperty(event)) {
            var callbacksChain = this._callbacks[event];
            for (var i = 0; i < callbacksChain.length; ++i) {
                callbacksChain[i](argument);
            }

            this._callbacks[event] = [];
        }
    };

    Datafeed.Container.prototype._logMessage = function(message) {
        if (this._enableLogging) {
            var now = new Date();
            // console.log("CHART LOGS: "+now.toLocaleTimeString() + '.' + now.getMilliseconds() + '> ' + message);
        }
    };

    Datafeed.Container.prototype.on = function(event, callback) {
        if (!this._callbacks.hasOwnProperty(event)) {
            this._callbacks[event] = [];
        }

        this._callbacks[event].push(callback);
        return this;
    };

    Datafeed.Container.prototype.onReady = function(callback) {
        let that = this;
        if (this._configuration) {
            setTimeout(function() {
                callback(that._configuration);
            }, 0);
        }
        else {
            this.on('configuration_ready', function() {
                callback(that._configuration);
            });
        }
    };

    Datafeed.Container.prototype.resolveSymbol = function(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
        this._logMessage("GOWNO :: resolve symbol "+ symbolName);
        Promise.resolve().then(() => {
            // console.log(this_vue.priceScale,'12345s313123122adaslast')


            // this._logMessage("GOWNO :: onResultReady inject "+'AAPL');
            // console.log(this_vue.priceScale,'123stf')
            onSymbolResolvedCallback({
                "name": this_vue.symbol,
                "timezone": "Asia/Shanghai",
                "pricescale": this_vue.priceScale,
                "minmov": 1, //minmov(最小波动), pricescale(价格精度), minmove2, fractional(分数)
                "minmov2": 0,//这是一个神奇的数字来格式化复杂情况下的价格。
                "ticker": this_vue.symbol,
                "description": bzName,
                "type": "bitcoin",
                "volume_precision": 8,
                // "exchange-traded": "sdt",
                // "exchange-listed": "sdt",
                //现在，这两个字段都为某个交易所的略称。将被显示在图表的图例中，以表示此商品。目前此字段不用于其他目的。
                "has_intraday": true,
                "has_weekly_and_monthly": true,
                "has_no_volume": false, //布尔表示商品是否拥有成交量数据。
                'session': '24x7',
                // 'supported_resolutions': ['1', '3', '5', '15', '30', '60', '120', '240', '360', '720', '1D', '3D', '1W', '1M']
                'supported_resolutions' : ['1', '5', '15', '30', '60','1D', '1W']
            });
        })
    };


    //初始化数据
    Datafeed.Container.prototype.getBars = function(symbolInfo, resolution, rangeStartDate, rangeEndDate, onHistoryCallback, onErrorCallback) {
        // if (rangeStartDate > 0 && (rangeStartDate + '').length > 10) {
        //   throw new Error(['Got a JS time instead of Unix one.', rangeStartDate, rangeEndDate]);
        // }

        if(resolution.indexOf('D')==-1&&resolution.indexOf('W')==-1&&resolution.indexOf('M')==-1){
            resolution=resolution+'min'
        }else if(resolution.indexOf('W')!=-1||resolution.indexOf('M')!=-1){
            resolution=resolution
        }
        var url = null;
        //if (__socket.__bh) {
            var symbol = symbolInfo.name.replace('/', '').toLowerCase();
            url = this_vue.next_timeshar_url + '?symbol=' + symbol + '&period=' + resolution;
       // } else {
        //    url = this_vue.new_timeshar_url + //'?' +
        //    '?from='+rangeStartDate+'&to='+rangeEndDate+'&symbol='+symbolInfo.name+'&period='+resolution+'&type='+this_vue.type
       // }

        $.ajax({
            url: url,
            type:'get',
            // {"id":1565769360,"period":"1min","base-currency":"ETH","quote-currency":"USDT","open":208.48,"close":208.37,
            // "high":208.49,"low":208.37,"vol":19280.976193,"amount":92.4997,"time":1565769360000,"volume":92.4997}

            // {"id":1565855760,"open":298.06,"close":298.12,"low":298.00,"high":298.8900,
            // "amount":177.095682315112540192,"vol":52823.466674,"count":110}
            success: function(res){
                if (res&& res.data && res.data.length > 0) {
                    res.data.forEach((item, i) => {
                        item.time = Number(item.Date*1000)
                        item.open = Number(item.Open)
                        item.close = Number(item.Close)
                        item.high = Number(item.High)
                        item.low = Number(item.Low)
                        item.volume = Number(item.Volume)
                    })
                    onHistoryCallback(res.data.reverse(), {
                        noData: false
                    })
                    onHistoryCallback([], {
                        noData: true
                    })

                }
                if (!res.data) {
                    onHistoryCallback([], {
                        noData: true
                    })
                }
                if(res.data&&res.data.length==0){
                    onHistoryCallback([],{noData:true})
                }
                // init_new_timeshar(res, function(data){
                //     onHistoryCallback(data,{noData:false})
                //     onHistoryCallback([],{noData:true})
                // })
                // return;
                /*
                __socket.__bh = false
                if (__socket.__bh) {
                    if(res&&res.data&&res.data.length>0) {
                        res.data.forEach((item,i)=>{
                            item.time = item.id * 1000
                            item['base-currency'] = symbolInfo.name.split('/')[0]
                            item.period = resolution
                            item['quote-currency'] = symbolInfo.name.split('/')[1]
                            item.volume = item.amount
                            item.open=Number(item.open)
                            item.close=Number(item.close)
                            item.high=Number(item.high)
                            item.low=Number(item.low)
                        })
                        onHistoryCallback(res.data.reverse(),{noData:false})
                        onHistoryCallback([],{noData:true})
                    }else{
                        onHistoryCallback([],{noData:true})
                    }
                } else {
                    if(res&&res.data&&res.data.length>0){
                        res.data.forEach((item,i)=>{
                            item.time = item.time * 1000
                            item.open=Number(item.open)
                            item.close=Number(item.close)
                            item.high=Number(item.high)
                            item.low=Number(item.low)
                            console.log(item.time)
                        })
                        [].reverse
                        onHistoryCallback(res.data.,{noData:false})
                        onHistoryCallback([],{noData:true})
                    }else{
                        onHistoryCallback([],{noData:true})
                    }
                }
                if(res.data&&res.data.length==0){
                    onHistoryCallback([],{noData:true})
                }*/

            }
        })

    };
    //实时数据
    Datafeed.Container.prototype.subscribeBars = function(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback) {
        console.log('实时数据')
        this_vue.onRealtimeCallback = onRealtimeCallback
    };

    Datafeed.Container.prototype.unsubscribeBars = function(listenerGUID) {

        this._barsPulseUpdater.unsubscribeDataListener(listenerGUID);

    };

    return new Datafeed.Container;
}

export default createFeed



// WEBPACK FOOTER //
// ./src/views/deal/components/AoTv-datafeed.js